/*
 * Created by alex@hackerbay.com on 21.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";

import {Button, Col, Container, Input, Row} from "reactstrap";

/**
 * Debug Menu to facilitate development and switching to all stages
 */
class DebugMenu extends React.Component {

    constructor(props){
        super(props);
    }

    render() {

        let appointmentConfirmationReset = "";
        const stageButtons = [];
        let errorStageButtons = [];
        const testuserButtons = [];

        const errorStageTitlesDebug = [
            "Request Callback",
            "Simulate Server Error",
            "Request Callback Confirm"
        ];

        const stageTitlesDebug = [
            "Welcome",
            "Appointment Intro",
            "Calendar",
            "Previous Tenant",
            "Check Information",
            "Current Status",
            "Confirm Appointment",
            "Waiting For Appointment (Package Tracking etc.)",
            "Appointment Day",
            "Router Setup",
            "Success",
            "Internet Problems"
        ];

        // build buttons for stages
        for(let i = 0;i<=11;i++){
            const urlIdent =  i === 5 ? "HB_DEBUG_DSL_APPOINTMENT_SELECTED" : i < 6 ? "HB_DEBUG_DSL": "HB_DEBUG_TT";
            stageButtons.push(
                <Button style={{margin: "5px"}} key={"debug-stage-button-"+i} onClick={() => {
                    // console.log(urlIdent);
                    this.props.updateState({urlIdent: urlIdent, debugStateOverride: i});
                }}>
                    Stage <b>{i}</b> ({stageTitlesDebug[i]})
                </Button>
            )
        }

        // build buttons for error stages
        for(let i = 5000;i<=5002;i++){
            errorStageButtons.push(
                <Button style={{margin: "5px"}} key={"debug-stage-button-"+i} onClick={() => {
                    this.props.updateState({urlIdent: "HB_DEBUG_TT", debugStateOverride: i});
                }}>
                    Stage <b>{i}</b> ({errorStageTitlesDebug[i-5000]})
                </Button>
            );
        }

        // build buttons for SDS testusers
        for(let i = 300;i<=355;i+=5){
            const urlIdent = "1T9999999999" + i;
            testuserButtons.push(
                <Button style={{margin: "5px"}} key={"debug-stage-button-"+i} onClick={() => {
                    // console.log(urlIdent);
                    this.props.updateState({urlIdent: urlIdent, debugStateOverride: i});
                }}>
                    Stage <b>{i}</b> {urlIdent} ({stageTitlesDebug[i]})
                </Button>
            );
        }

        return <Container>

            <Row>
                <h3>CustomerStatus Test Users</h3>
            </Row>
            <Row>
                <h4>DSL</h4>
            </Row>
            <Row>
                <a href={"/?urlIdent=1224013096-28"}>unselected</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=8004563067-39"}>unselected</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=7543173096-45"}>selected</a>
            </Row>
            <Row>
                <h4>TT</h4>
            </Row>
            <Row>
                <a href={"/?urlIdent=2T0F1O3O5I3O5T6U"}>available </a>
            </Row>
            <Row>
                <a href={"/?urlIdent=0L0R1O3O4E7I8L5F"}>unchangeable</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=1O0F1O3O4T0R7O6M"}>available </a>
            </Row>
            <Row>
                <a href={"/?urlIdent=2I0F1O3O5I5I8I4U"}>selected</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=2I0F1O3O4E2M1F4E"}>checked</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=1R0F1O3O4F6F0F4U"}>checked</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=1O0F1O3O4O0T5O6O"}>available </a>
            </Row>
            <Row>
                <a href={"/?urlIdent=1L0F1O3O4T7O2F5T"}>available </a>
            </Row>

            <Row>
                <h3>SDS Test Users</h3>
            </Row>
            <Row>
                <a href={"/?urlIdent=1T99999999991"}>DS360 Test User (1T99999999991)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=1T9999999999350"}>Stage 8 - Appointment Day - 1T999999999350</a>
            </Row>
            <Row>
                {testuserButtons}
            </Row>

            <Row>
                <h3>Fake / Mock Test Users</h3>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_DSL"}>Fake User Stage 1</a>
                <a href={"/?urlIdent=HB_DEBUG_DSL_APPOINTMENT_SELECTED"}>Fake User Stage 5</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT"}>Fake User (With hardware) Waiting for appointment</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_NO_HARDWARE"}>Fake User (NO hardware)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_21_DAYS"}>Fake User (NO hardware and 21 Days until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_14_DAYS"}>Fake User (NO hardware and 14 Days until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_12_DAYS"}>Fake User (NO hardware and 12 Days until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_8_DAYS"}>Fake User (NO hardware and 8 Days until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_3_DAYS"}>Fake User (NO hardware and 3 Days until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_2_DAYS"}>Fake User (NO hardware and 2 Days until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_1_DAYS"}>Fake User (NO hardware and 1 Day until appointment)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_TODAY_MORNING"}>Fake User (With hardware and appointment today morning)</a>
            </Row>
            <Row>
                <a href={"/?urlIdent=HB_DEBUG_TT_TODAY_AFTERNOON"}>Fake User (With hardware and appointment today afternoon)</a>
            </Row>



            <br/>

            <Row>
                <Row>
                    <h3>Access Stages using an "empty" user</h3>
                </Row>
                <Row>
                    {stageButtons}
                </Row>
                <br/>

                <Row>
                    {errorStageButtons}
                </Row>
                <br/>
            </Row>
        </Container>
    }
}


/**
 * check if current user (urlIdent) is a debug/test user
 * debug/test user = if urlIdent contains HB_DEBUG or begins with 1T99999999.....
 * @param urlIdent
 * @returns {boolean}
 */
function isDebugUser(urlIdent){
    return urlIdent.indexOf("HB_DEBUG") > -1 || urlIdent.indexOf("1T99999999") > -1;
}

export default translate("translations")(DebugMenu);
export {isDebugUser}